import styled from "styled-components";
import { MEDIA_QUERIES, theme } from "@ifgengineering/component-library";

export const StartupDetailMainContent = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 8rem;

  @media ${MEDIA_QUERIES.TAB_LAND} {
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    gap: 32px;
  }
`;

export const StartupDetailMain = styled.main`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const StartupDetailFullInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const StartupDetailAside = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media ${MEDIA_QUERIES.TAB_LAND} {
    width: 100%;
    gap: 16px;
  }
`;

export const StartupDetailVideo = styled.div`
  border-radius: 8px;
  border: none;
  overflow: hidden;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  position: relative;

  & > iframe {
    position: absolute;
    height: 100%;
    width: 100%;
    border: none;
  }
`;

export const StartupDetailLogoContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const StartupDetailDataCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 32px;
  min-height: 144px;
  gap: 8px;
  border: 1px solid ${theme.colors.SLATE200};
  border-radius: 16px;
  width: 100%;
  background: ${theme.colors.WHITE};
`;

export const StartupDetailSocialsContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;

  & > a {
    text-decoration: none;
  }
`;

export const StartupDetailSocialButton = styled.button`
  padding: 6px 16px;
  width: fit-content;
  border: 1px solid ${theme.colors.SLATE300};
  border-radius: 4px;
  display: flex;
  gap: 8px;
  align-items: center;
  background-color: ${theme.colors.WHITE};
  cursor: pointer;

  &:hover {
    background-color: ${theme.colors.SLATE100};
  }
`;
